import { ref } from 'vue'
import { useAppStore } from '../stores/appStore'
import { adaptColor } from '../utils/adaptColor'

const colorCache = new Map<string, string>()

export function extractDominantColor(imageSrc: string, timeoutMs = 600): Promise<string> {
  return new Promise((resolve) => {
    if (!imageSrc || typeof window === 'undefined' || process.env.NODE_ENV === 'test') {
      resolve('139, 195, 75')
      return
    }

    if (colorCache.has(imageSrc)) {
      resolve(colorCache.get(imageSrc)!)
      return
    }

    let settled = false
    const finish = (color: string) => {
      if (!settled) {
        settled = true
        clearTimeout(timer)
        colorCache.set(imageSrc, color)
        resolve(color)
      }
    }

    const timer = setTimeout(() => {
      finish('139, 195, 75')
    }, timeoutMs)

    try {
      const img = new Image()
      img.crossOrigin = 'anonymous'
      
      img.onload = () => {
        try {
          const canvas = document.createElement('canvas')
          canvas.width = 1
          canvas.height = 1
          const ctx = canvas.getContext('2d')
          if (!ctx) {
            finish('139, 195, 75')
            return
          }
          
          ctx.drawImage(img, 0, 0, 1, 1)
          const data = ctx.getImageData(0, 0, 1, 1).data
          if (data[3] === 0) {
            finish('139, 195, 75')
            return
          }
          finish(`${data[0]}, ${data[1]}, ${data[2]}`)
        } catch {
          finish('139, 195, 75')
        }
      }
      
      img.onerror = () => {
        finish('139, 195, 75')
      }
      
      img.src = imageSrc
    } catch {
      finish('139, 195, 75')
    }
  })
}

export function useColorThief() {
  const extractedColor = ref<string>('139, 195, 75')
  const store = useAppStore()

  const extractColor = async (imageSrc: string): Promise<string> => {
    const rawRgb = await extractDominantColor(imageSrc)
    const adapted = adaptColor(rawRgb, store.darkMode)
    extractedColor.value = adapted
    return adapted
  }

  return {
    extractedColor,
    extractColor
  }
}
